import * as React from "react"
const IconQuestionMark = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={17}
        height={18}
        fill="none"
        {...props}
    >
        <path
            stroke="#63798F"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.496 13.167v.008m0-2.925A1.25 1.25 0 0 1 9.33 9a2.166 2.166 0 1 0-2.5-3.333M.996 9a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Z"
        />
    </svg>
)
export default IconQuestionMark
